import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { Box, IconButton } from "@mui/material";
import { EmailOutlined, GitHub, LinkedIn } from "@mui/icons-material";

export default function Footer() {
  return (
    <Box sx={{ py: 5 }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        flexDirection={{ xs: "column", sm: "row" }}
        sx={{ fontSize: "12px" }}
        size={12}
        spacing={4}
      >
        <Grid sx={{ order: { xs: 2, sm: 1 } }}>
          <Typography variant="body2" color="text.secondary">
            Abdulrahman Othman © 2024
          </Typography>
        </Grid>
        <Grid container columnSpacing={4} sx={{ order: { xs: 1, sm: 2 } }}>
          <Grid>
            <IconButton 
              aria-label="Email" 
              component="a" 
              href="mailto:supremache@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <EmailOutlined />
            </IconButton>
          </Grid>
          <Grid>
            <IconButton 
              aria-label="GitHub" 
              component="a" 
              href="https://github.com/Supremache"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GitHub />
            </IconButton>
          </Grid>
          <Grid>
            <IconButton 
              aria-label="LinkedIn" 
              component="a" 
              href="https://www.linkedin.com/in/abdulrahman-othman-5a4a1331a/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedIn />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
